import { Box, TextInput } from '@mantine/core';

import type { CellContext } from '@tanstack/react-table';
import type { ApiKeyResponse, ApiKeysTableMeta } from './types';

const NameCell = ({ row, table }: CellContext<ApiKeyResponse, string>) => {
  const meta = table.options.meta as ApiKeysTableMeta;
  const key = row.original;

  if (meta.editing && meta.editing.keyId === key.id) {
    return (
      <TextInput
        size="xs"
        value={meta.editing.value}
        onChange={(e) => meta.onChangeEdit(key.id, e.currentTarget.value)}
        onBlur={() => meta.onBlurEdit(key)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') meta.onBlurEdit(key);
          if (e.key === 'Escape') meta.onCancelEdit();
        }}
        autoFocus
      />
    );
  }

  return (
    <Box style={{ cursor: 'pointer' }} onClick={() => meta.onStartEdit(key)}>
      {key.name}
    </Box>
  );
};

export default NameCell;
